import React from 'react';
import { useLanguage } from '../translations/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-content">
        <img
          src="https://customer-assets.emergentagent.com/job_traditional-medicine-3/artifacts/f5y9qdpg_Logo.png"
          alt="Tranquil Acupuncture"
          className="hero-logo" />

        <h1 className="hero-title">
          {t.hero.title.split('\n').map((line, i) =>
          <React.Fragment key={i}>
              {line}
              {i < t.hero.title.split('\n').length - 1 && <br />}
            </React.Fragment>
          )}
        </h1>
        <p className="hero-subtitle">
          {t.hero.subtitle}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-8">
          <button onClick={scrollToBooking} className="btn-primary">
            {t.hero.bookCTA}
          </button>
          <button
            onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
            className="btn-secondary">

            {t.hero.exploreCTA}
          </button>
        </div>
      </div>
    </section>);

};

export default Hero;